<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <beautiful-chat
                :participants="participants"
                :onMessageWasSent="onMessageWasSent"
                :messageList="messageList"
                :newMessagesCount="newMessagesCount"
                :isOpen="isChatOpen"
                :close="closeChat"
                :open="openChat"
                :showEmoji="false"
                :showFile="false"
                :showTypingIndicator="showTypingIndicator"
                :showLauncher="true"
                :showCloseButton="true"
                :colors="colors"
                :alwaysScrollToBottom="alwaysScrollToBottom"
                :messageStyling="messageStyling"
                placeholder="Nachricht schreiben..."
        >
            <template v-slot:header>
                <p style="margin: auto; text-align: center; font-weight: bold">Teilnehmer: <span style="font-weight: normal">{{participants.map(m=>m.name).join(', ')}}</span></p>
            </template>
            <template v-slot:user-avatar="{ message, user }">
                <div>
                </div>
            </template>
            <template v-slot:text-message-body="{ message }">
                <p style='font-weight: bold; margin-bottom: 3px; font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; margin-left: -12px'>
                    {{message.data.meta_name}}:
                </p>
                <p style="margin-left: -12px; margin-bottom: 8px">{{message.data.text}}</p>
                <p style="text-align: right; font-weight: lighter; font-size: 12px; margin-bottom: 0px; margin-top: 8px; margin-right: -12px">
                    {{message.data.meta}}
                </p>
            </template>
            <template v-slot:text-message-toolbox="{ message }">
            </template>
        </beautiful-chat>
    </div>
</template>

<script>
    import {Server_URL_BASE} from "../../shared/utils";

    export default {
        name: 'Chat',
        mounted() {
            this.customerNumber = this.$route.params.customer_number;
            this.chatId = this.$route.query.chat_id;
            this.userToken = this.$route.query.user_token;
            console.log(this.customerNumber);
            console.log(this.chatId);
            console.log(this.userToken);

            this.$http.get(
                Server_URL_BASE + '/chat/complete/' + this.customerNumber + "?chat_id="+this.chatId+"&token="+this.userToken
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
                participants: [], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
                messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
                newMessagesCount: 0,
                isChatOpen: true, // to determine whether the chat window should be open or closed
                showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
                colors: {
                    header: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    launcher: {
                        bg: '#4e8cff'
                    },
                    messageList: {
                        bg: '#ffffff'
                    },
                    sentMessage: {
                        bg: '#4e8cff',
                        text: '#ffffff'
                    },
                    receivedMessage: {
                        bg: '#eaeaea',
                        text: '#222222'
                    },
                    userInput: {
                        bg: '#f4f7f9',
                        text: '#565867'
                    }
                }, // specifies the color scheme for the component
                alwaysScrollToBottom: true, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
                messageStyling: false, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)

                customerNumber: null,
                chatId: null,
                userToken: null,
                interval: null,
            }
        },
        methods: {
            onMessageWasSent(message) {
                // called when the user sends a message
                if (this.interval !== null) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
                let body = {
                    token: this.userToken,
                    chat_id: this.chatId,
                    message: message.data.text,
                };
                if (this.messageList.length > 0) {
                    body.last_date = this.messageList[this.messageList.length-1].data.meta_date;
                }
                this.$http.post(
                    Server_URL_BASE + '/chat/message/' + this.customerNumber, body
                ).then(this.responseOkGet, this.responseError)
            },
            openChat() {
                // called when the user clicks on the fab button to open the chat
                this.isChatOpen = true
                this.newMessagesCount = 0
            },
            closeChat() {
                // called when the user clicks on the botton to close the chat
                this.isChatOpen = false
            },
            responseError(response) {
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                if (response.status === 200) {
                    if (response.body.users !== undefined) {
                        for (let i = 0; i < response.body.users.length; i++) {
                            this.participants.push(response.body.users[i]);
                        }
                    }
                    for (let i = 0; i < response.body.messages.length; i++) {
                        this.messageList.push(response.body.messages[i]);
                    }
                    this.newMessagesCount = this.isChatOpen ? this.newMessagesCount : this.newMessagesCount + response.body.messages.length;
                    if (this.interval === null) {
                        this.interval = setInterval(this.refresh, 2000);
                    }
                } else {
                    console.log(response);
                }
            },
            refresh() {
                let url = Server_URL_BASE + '/chat/update/' + encodeURIComponent(this.customerNumber) + "?chat_id="+encodeURIComponent(this.chatId)+"&token="+encodeURIComponent(this.userToken);
                if (this.messageList.length != 0) {
                    url += "&last_date=" + encodeURIComponent(this.messageList[this.messageList.length-1].data.meta_date);
                }
                this.$http.get(
                    url
                ).then(this.responseOkGet, this.responseError)
            }
        }
    }
</script>

<style>
    .sc-message {
        width: 340px;
    }
    .sc-message--text .sc-message--toolbox {
        display: none;
    }

</style>

<style scoped>


</style>
